<div class="body">
<nav class="navbar navbar-default">
    <div class="container-fluid">
      <div class="navbar-header">
        <a class="navbar-brand" href="#">
            <img src="assets/images/mu_logo.png" alt="logo" class="logo">
            <span class="seperator">|</span>
            <img src="assets/images/elogo.png" alt="logo" class="elogo">
        </a>
      </div>
      <ul class="nav navbar-nav navbar-right">
        <!-- <li><a href="http://univ.secur.co.in/University/login" class="click-btn">CLICK HERE TO CONTINUE</a></li> -->
        <li class="right-nav"><a href="#">Home</a></li>
        <li class="right-nav"><a routerLink="/faq">FAQ</a></li>
      </ul>
    </div>
</nav>
<img src="assets/images/banner.jpg" alt="banner" class="banner">
<div class="process-section">
    <div class="container-fluid">
        <!-- <div class="col-md-12">
            <img src="assets/images/process.jpg" alt="process" class="process">
        </div> -->
        <div class="row">

       
        <div class="col-md-6">
            <h2 class="sub-hd">University of Mumbai</h2>
            <p class="line22">Just follow the below steps and get your mark sheets verified online.</p>
        </div>
        <div class="col-md-6">
          <a [routerLink]="'/login'" class="click-btn pull-right">CLICK HERE TO CONTINUE</a>
        </div>
      </div>
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-3 d-col">
                    <div class="icon-wrap">
                        <img src="assets/images/icon1.png" alt="icon" class="icon one">
                    </div>
                    <div class="txt-wrap">
                        <h3 class="sub-hd">Step 1</h3>
                        <p class="line">Select Student Registration <br>or Third Party Registration.</p>
                    </div>
                </div>
                <div class="col-md-3 d-col">
                    <div class="icon-wrap">
                        <img src="assets/images/icon2.png" alt="icon" class="icon two">
                    </div>
                    <div class="txt-wrap">
                        <h3 class="sub-hd">Step 2</h3>
                        <p class="line">Register with your <br>complete information.</p>
                    </div>
                </div>
                <div class="col-md-3 d-col">
                    <div class="icon-wrap">
                        <img src="assets/images/icon3.png" alt="icon" class="icon three">
                    </div>
                    <div class="txt-wrap">
                        <h3 class="sub-hd">Step 3</h3>
                        <p class="line">Authenticate yourself <br>with your email ID.</p>
                    </div>
                </div>
                <div class="col-md-3 d-col">
                    <div class="icon-wrap">
                        <img src="assets/images/icon4.png" alt="icon" class="icon four">
                    </div>
                    <div class="txt-wrap">
                        <h3 class="sub-hd">Step 4</h3>
                        <p class="line">Update all required fields. <br>Ensure the details are the <br>same as the ones in the <br>mark sheets.</p>
                    </div>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-md-3 d-col mt-30">
                    <div class="icon-wrap">
                        <img src="assets/images/icon5.png" alt="icon" class="icon five">
                    </div>
                    <div class="txt-wrap">
                        <h3 class="sub-hd">Step 5</h3>
                        <p class="line">Upload ALL Semester mark<br>
                            sheets. Any mark sheets<br>
                            missing will be treated as<br>
                            an incomplete request, and<br>
                            will not be processed.</p>
                    </div>
                </div>
                <div class="col-md-3 d-col mt-30 mtr-60">
                    <div class="icon-wrap">
                        <img src="assets/images/icon6.png" alt="icon" class="icon six">
                    </div>
                    <div class="txt-wrap">
                        <h3 class="sub-hd">Step 6</h3>
                        <p class="line">Pay the required<br>
                            e-verification fees online,<br>
                            by choosing any of the<br>
                            payment options available.</p>
                    </div>
                </div>
                <div class="col-md-3 d-col mt-30">
                    <div class="icon-wrap">
                        <img src="assets/images/icon7.png" alt="icon" class="icon seven">
                    </div>
                    <div class="txt-wrap">
                        <h3 class="sub-hd">Step 7</h3>
                        <p class="line">e-Verification report<br>
                            will be sent to your<br>
                            registered email ID.</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    
                </div>
            </div>
        </div>
    </div>        
</div>


<div class="contact-section">
    <div class="contact-form">
      <div class="container">
        <div class="row">
          <div class="col-md-4">
            <h3 class="contact-form-hd">Fill the form & we will get back.</h3>
            <form [formGroup] = "queryForm">
              <input type="text" class="form-control form-input" placeholder="Enter your email id"
               formControlName="emailid" [pattern]="emailPattern"
              id="emailid" [ngClass]="{'is-invalid': submitted && f.emailid.errors }">
              <div *ngIf="submitted && f.emailid.errors" class="invalid-feedback">
                <div *ngIf="f.emailid.errors.required">Emailid is required</div>
                <div *ngIf="f.emailid.errors.pattern">Email must be a valid email address
                </div>
              </div>
              <textarea class="form-control form-input" placeholder="Enter your Query" 
               formControlName="query" 
              id="query" [ngClass]="{'is-invalid': submitted && f.query.errors }"></textarea>
              <div *ngIf="submitted && f.query.errors" class="invalid-feedback">
                <div *ngIf="f.query.errors.required">Query is required</div>
              </div>
              <button class="form-btn" (click)="sendQuery()">Submit</button>
            </form>
          </div>
          <div class="col-md-8"></div>
        </div>
      </div>
    </div>

    <ng-template  #showModalBox class="modal fade " id="successModal" tabindex="-1" role="dialog" let-c="close"
    let-d="dismiss" aria-labelledby="resetPasswordModalLabel" aria-hidden="false">
    
    <div class="modal-content">
      <div class="modal-header success-modal-header">
        <h5 class="modal-title icon-title" id="resetPasswordModalLabel">
          <span class="icon-wrap bg-theme"><img src="assets/images/thumb-up.png" class="fa-icon-modal" alt="img"></span>
        </h5>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12">
            <h3 class="success-text">Success</h3>
            <p class="reset-hd2">Thanks for contacting us. Your query is registered with us.</p>
          </div>
        </div>
        <button class="approve-modal-btn2 bg-theme mr-auto" data-dismiss="modal" (click)="refresh()">Done</button>
      </div>
    </div>
  </ng-template>

  <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="timer" [fullScreen]="true">
    <p style="color: white"> Loading... </p>
  </ngx-spinner>

    <div class="footer">
        <div class="d-flex-footer">
            <a href="#"><img src="assets/images/footericon1.jpg" alt="icon" class="footer-icon"></a>
            <a href="#"><img src="assets/images/footericon2.jpg" alt="icon" class="footer-icon"></a>
            <a href="#"><img src="assets/images/footericon3.jpg" alt="icon" class="footer-icon"></a>
        </div>
        <div class="d-flex-footer">
            <a href="#" class="footer-link">Home</a>
            <a href="#" class="footer-link">Process</a>
            <a href="#" class="footer-link">Terms</a>
            <a href="#" class="footer-link">Privacy Policy</a>
            <a routerLink="/refundPolicy" class="footer-link">Refund Policy</a>
            <a href="#" class="footer-link">Sitemap</a>
        </div>
    </div>
</div>
</div>